import { useCallback, useState } from 'react';

export type OrchestratorState =
  | 'idle'
  | 'listening'
  | 'thinking'
  | 'speaking'
  | 'error';

export interface ActivePersonaLite {
  id: string;
  name: string;
  voice?: string;
  mood?: string | null;
  description?: string | null;
}

/**
 * Top-level conversation state machine. Stage 2 only cycles
 * idle → thinking → idle (text only). `listening` and `speaking` are
 * reserved for Stage 3+ voice paths.
 */
export function useOrchestrator(initialPersona: ActivePersonaLite | null = null) {
  const [state, setState] = useState<OrchestratorState>('idle');
  const [currentPersona, setCurrentPersona] =
    useState<ActivePersonaLite | null>(initialPersona);

  const toIdle = useCallback(() => setState('idle'), []);
  const toThinking = useCallback(() => setState('thinking'), []);
  const toError = useCallback(() => {
    setState('error');
    window.setTimeout(() => setState('idle'), 2000);
  }, []);

  return {
    state,
    setState,
    currentPersona,
    setCurrentPersona,
    toIdle,
    toThinking,
    toError,
  };
}
